import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopMembers } from 'src/services/Scope.client';

export interface SettingsState {
  isCompanionCollapsed: boolean;
  lastScopeCreated: Record<string, TopMembers>;
}

const initialState: SettingsState = {
  isCompanionCollapsed: false,
  lastScopeCreated: {} as Record<string, TopMembers>,
};

const uiPoseSlice = createSlice({
  name: 'uiPose',
  initialState: initialState,
  reducers: {
    setLastScopeCreated: (state, action: PayloadAction<[string, TopMembers]>) => {
      state.lastScopeCreated[action.payload[0]] = action.payload[1];
    },
    toggleCompanionCollapse: (state) => {
      state.isCompanionCollapsed = !state.isCompanionCollapsed;
    },
  },
});

export const { setLastScopeCreated, toggleCompanionCollapse } = uiPoseSlice.actions;

export default uiPoseSlice.reducer;
